import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const desktopTutorial = (id, buttonText) => [
  {
    element: '.ro_tool_visibilities',
    intro: `Tutaj klikasz jeżeli chcesz ustawić widoczność elementów lub warstw na mapie. To tylko skrót do ustawień... Ciekawy? Chodź dalej.`
  },
  // {
  //   element: '.ro_tool_anchor',
  //   intro:
  //     'Ta opcja uruchomi generowanie url i kotwicy do fragmentu mapy. Dzięki temu możesz dzielić się linkami ze znajomymi.',
  // },
  {
    element: '.ro_tool_printScreen',
    intro: ' Wracają zrzuty - ta opcja też czasami się przydaje. Wystarczy jedno kliknięcie i masz kawałek RO na dysku!'
  },
  {
    element: '.ro_tool_favorites',
    intro:
      'Nowe RO to również nowe funkcjonalności. Ta ikona symbolizuje ulubione lokalizacje, z tego poziomu zrobisz szybki rajd gdzie tylko chcesz!'
  },
  {
    element: '.ro_tool_geolocation',
    intro:
      'W nowym RO nie zabraknie geolokazlizacji. Po jej uruchomieniu na samej górze listy ulubionych miejsc będzie odnośnik do aktualej, Twojej pozycji.'
  },
  {
    element: '.ro_tool_zoomIn',
    intro: 'Tutaj przybliżysz mapę. Możesz to zrobić też scrollem lub touchpadem.'
  },
  {
    element: '.ro_tool_zoomOut',
    intro: 'Tym przyciskiem cofniesz zoom.'
  },
  {
    element: '.ro_tool_search',
    intro:
      'W nowym RO możesz również robić rajdy do wyszukiwanych lokalizacji, wynik możesz zawęzić nawet do swojego adresu zamieszkania!'
  },
  {
    element: '.ro_tool_fanpage',
    intro: 'Ten przycisk odeśle Cię do aktualności na naszym fanpage`u. Tam ciągle się coś dzieje, nie ma nudy ;)'
  },
  {
    element: '.ro_tool_history',
    intro: 'W nowym RO będą również dane archiwalne.'
  },
  {
    element: '.ro_tool_anim_data',
    intro:
      'Suwakami fioletowymi ustawisz zakres czasu dla animacji (początek i koniec). Zielony służy do nawigowania danymi w czasie.',
    highlightClass: 'ro_tool_anim'
  },
  {
    element: '.ro_tool_animation',
    intro: 'Po ustawieniu zakresu dla animacji w dowolnej chwili możesz ją uruchomić i zmienić jej prędkość.',
    highlightClass: 'ro_tool_anim'
  },
  {
    element: '.ro_tool_menu',
    intro: `Tu otworzysz menu aplikacji. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
